import { IconLocationOutline } from 'components/icons';
import ModalWrapper from 'components/shared/modal-wrapper';
import { useModal } from 'hooks';
import dynamic from 'next/dynamic';
import { DetailPageContext } from 'pages/[ket-qua-tim-kiem]/[chi-tiet-tin-rao]';
import { Fragment, useContext } from 'react';

const MapModal = dynamic(
  () => import('components/desktop/detail/main-section/main-section-left/map-section//map-modal'),
  { ssr: false },
);

const MapSection = () => {
  const { realEstate } = useContext(DetailPageContext).pageData ?? {};
  const { map } = realEstate ?? {};
  const { showing: showingMapModal, toggle: toggleMapModal } = useModal();

  return (
    <Fragment>
      <div id='map-section' className='flex h-[40px] items-center justify-between space-x-[24px]'>
        <div className='flex items-center space-x-[10px]'>
          <div className='flex h-[30px] w-[30px] items-center justify-center rounded-[8px] bg-background'>
            <IconLocationOutline className='h-[18px] w-[18px]' />
          </div>
          <h2 className='text-[18px] font-[600] leading-[23px]'>Vị trí bất động sản</h2>
        </div>
        <div className='flex items-center space-x-[10px]'>
          <div className='h-[24px] w-[24px] bg-[url("/icons/map.svg")] bg-cover bg-center bg-no-repeat' />
          <button
            type='button'
            className='text-[12px] font-[600] leading-[15px] text-primary'
            onClick={toggleMapModal}
          >
            Xem bản đồ
          </button>
        </div>
      </div>
      <ModalWrapper showing={showingMapModal}>
        <MapModal map={map} onClose={toggleMapModal} />
      </ModalWrapper>
    </Fragment>
  );
};

export default MapSection;
